import React from 'react';
import { Link } from 'gatsby';
import Marquee from 'react-fast-marquee';
import FancyTitle from '../fancy-title';
import { getStoryblokAlt } from '../../helpers/common';

function PartnerLogo({ partner }) {
  return (
    <div className="pointer-events-none">
      {partner.filename ? (
        <img
          src={partner.filename && !partner.filename.includes('.svg') ? `${partner.filename}/m/288x0/filters:format(webp)` : partner.filename}
          width={partner.logoWidth || 144}
          height={partner.logoHeight || 48}
          className={`h-12 w-auto max-w-[144px] object-contain ${
            partner.filename?.includes('battery-included') || partner.filename?.includes('return_prime') ? '' : 'invert'
          } dark:invert-0`}
          // Real alt text from the Storyblok asset; the marquee wrapper is aria-hidden so it won't be double-announced
          alt={getStoryblokAlt(partner, partner.title || '')}
          loading="lazy"
        />
      ) : (
        <h4>{partner.title}</h4>
      )}
    </div>
  );
}

export default function PartnerLogos({ blok }) {
  if (!blok.blocks.length) {
    return null;
  }

  const titleBlock = blok.blocks.find((item) => item.component === 'Headlines');

  const even = blok?.first_row?.map(
    (row) => ({ image: row.image[0], url: row.url, uid: row._uid }),
  ) || [];

  const odd = blok?.second_row?.map(
    (row) => ({ image: row.image[0], url: row.url, uid: row._uid }),
  ) || [];

  return (
    <div className="py-10 px-4 lg:px-16">
      {titleBlock && (
        <FancyTitle
          text={titleBlock.headline}
          className="text-center my-10"
          tag="h2"
          subtitle={titleBlock.subline}
          textAlign="lg:text-center"
          marginBottom="mb-20"
        />
      )}

      {/* Decorative Marquee – completely ignored by keyboard and screen readers */}
      <div
        className="flex flex-col gap-8"
        aria-hidden="true"
        role="presentation"
      >
        {[even, odd].map((slider, i) => (
          <Marquee
            key={`marquee-row-${i}`}
            speed={i === 0 ? 70 : 78}
            gradient={false}
            autoFill
            pauseOnHover
          >
            {slider.map((item) => {
              const partnerLogo = (
                <PartnerLogo
                  partner={item.image}
                  key={item.uid || item.image.id}
                />
              );

              { /* Remove link – decorative only */ }
              return (
                <div className="mx-8 flex-shrink-0" key={item.uid}>
                  {item.url?.story ? (
                    <Link
                      to={item.url.story?.full_slug ? `/${item.url.story?.full_slug}` : ''}
                      title={item.url?.link_title || undefined}
                      aria-label={`Learn more about partnership with ${getStoryblokAlt(item.image)}`}
                    >
                      {partnerLogo}
                    </Link>
                  ) : (
                    partnerLogo
                  )}
                </div>
              );
              // return (
              //   <div className="mx-8 flex-shrink-0" key={item.uid}>
              //     {partnerLogo}
              //   </div>
              // );
            })}
          </Marquee>
        ))}
      </div>
    </div>
  );
}
